export default __webpack_public_path__ + "28b2547f499c75ad2c87270476c03d7a.svg";